import { REMOVE_SUPPLIER_DESTINATION_MAPPING_FAILURE, REMOVE_SUPPLIER_DESTINATION_MAPPING_REQUEST, REMOVE_SUPPLIER_DESTINATION_MAPPING_RESET, REMOVE_SUPPLIER_DESTINATION_MAPPING_SUCCESS } from "redux/actions/action-type"


const initialState = {
    isRemoveSupplierDestinationMappingLoading: false,
    isRemoveSupplierDestinationMappingSuccess: false,
    isRemoveSupplierDestinationMappingFail: false,
    removeSupplierDestinationMappingResponse: {}
}

export const removeSupplierDestinationMappingReducer = (state = initialState, { type, removeSupplierDestinationMappingResponse }) => {
    switch (type) {
        case REMOVE_SUPPLIER_DESTINATION_MAPPING_REQUEST:
            return {
                ...state,
                isRemoveSupplierDestinationMappingLoading: true,
                isRemoveSupplierDestinationMappingSuccess: false,
                isRemoveSupplierDestinationMappingFail: false
            }
        case REMOVE_SUPPLIER_DESTINATION_MAPPING_SUCCESS:
            return {
                ...state,
                removeSupplierDestinationMappingResponse: removeSupplierDestinationMappingResponse,
                isRemoveSupplierDestinationMappingLoading: false,
                isRemoveSupplierDestinationMappingSuccess: true,
                isRemoveSupplierDestinationMappingFail: false
            }
        case REMOVE_SUPPLIER_DESTINATION_MAPPING_FAILURE:
            return {
                ...state,
                removeSupplierDestinationMappingResponse: removeSupplierDestinationMappingResponse,
                isRemoveSupplierDestinationMappingLoading: false,
                isRemoveSupplierDestinationMappingSuccess: false,
                isRemoveSupplierDestinationMappingFail: true
            }
        case REMOVE_SUPPLIER_DESTINATION_MAPPING_RESET:
            return {
                ...initialState
            }
        default:
            return {
                ...state
            }
    }
}